import { useState } from 'react';

import { protectedResources } from "../authConfig";

const useFetchWithOutMsal = () => {
  
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    /**
     * Execute a fetch request with the given options
     * @param {string} method: GET, POST, PUT, DELETE
     * @param {String} endpoint: The endpoint to call
     * @param {Object} data: The data to send to the endpoint, if any 
     * @returns JSON response
     */
    const execute = async (method, endpoint, data = null) => {
            try {
                let responseToken = null;
                let token = null;
                const headersToken = new Headers();
                headersToken.append('Content-Type', 'application/x-www-form-urlencoded');
                const bodyToken = new URLSearchParams();
                bodyToken.append('grant_type', 'client_credentials');
                bodyToken.append('client_id', protectedResources.apiDenuncia.clientId);
                bodyToken.append('client_secret', protectedResources.apiDenuncia.clientSecret);
                bodyToken.append('scope', protectedResources.apiDenuncia.scope);
                let optionsToken = {
                    method: 'POST',
                    headers: headersToken,
                    body: bodyToken.toString(),
                };
                setIsLoading(true);
                responseToken = await (await fetch(protectedResources.apiDenuncia.endpointToken, optionsToken)).json();
                token = responseToken.access_token;
                setIsLoading(false);
                
                let response = null;
                const headers = new Headers();           
                headers.append('Authorization', 'Bearer ' + token);

                if (data) headers.append('Content-Type', 'application/json');

                let options = {
                    method: method,
                    headers: headers,
                    body: data ? JSON.stringify(data) : null,
                };

                setIsLoading(true);

                response = await (await fetch(endpoint, options)).json();
                setData(response);
                setIsLoading(false);
                return response;
            } catch (e) {
                setError(e);
                setIsLoading(false);
                throw e;
            }
    };

    return {
        isLoading,
        error,
        data,
        execute
    };
};

export default useFetchWithOutMsal; 